// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"a99d72f0","513":"40e81459","787":"0a0a89ea"}[chunkId] + ".chunk.js";
};